import React from "react";
import { Tooltip } from "antd";

interface TypeMoreProps {
  count: number;
  onClick(): void;
  expand: boolean;
}

/**
 * @name More 更多按钮
 */
const More: React.FC<TypeMoreProps> = ({ count, expand, onClick }) => (
  <Tooltip title={expand ? "" : "Show all"}>
    <div className="guideline-expand">
      <span onClick={onClick}>
        {expand ? `Show less` : `+${count > 99 ? 99 : count}`}
      </span>
    </div>
  </Tooltip>
);

export default More;
